<template>
  <div class="user-page">
    <div class="user-page__header">
      <div class="user-page__header-left">
        <div class="user-page__title">离职继承</div>
        <div class="user-page__subtitle">共 {{ total }} 位员工</div>
      </div>
    </div>

    <div class="user-content-card">
      <div class="user-search-bar">
        <div class="user-search-main">
          <div class="user-search-field">
            <i class="el-icon-search user-search-field__icon"></i>
            <input v-model="listQuery.BindPhone" placeholder="员工手机" class="user-search-field__input" @keyup.enter="getList" />
          </div>
          <button class="user-search-btn user-search-btn--ghost" @click="reset">重置</button>
          <button class="user-search-btn" @click="getList">查找</button>
        </div>
      </div>

      <div class="user-table-wrap">
        <div class="tableAutoMain">
          <el-table ref="Table1" :data="KhList" style="width: 100%" @selection-change="handleSelectionChange" class="apple-table">
            <el-table-column align="center" show-overflow-tooltip label="用户昵称">
              <template slot-scope="scope">{{ scope.row.NickName }}</template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip label="手机" fixed>
              <template slot-scope="scope">{{ scope.row.BindPhone | setPhoneType }}</template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip label="拥有客户数量">
              <template slot-scope="scope">{{ scope.row.CustomerCount }}</template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip label="账号">
              <template slot-scope="scope">{{ scope.row.UserAccount }}</template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="130" fixed="right">
              <template slot-scope="scope">
                <el-tooltip content="清空用户客户数据" placement="top">
                  <span class="user-action-icon user-action-icon--red" @click="handleDelete(scope.$index, scope.row)">
                    <i class="el-icon-delete"></i>
                  </span>
                </el-tooltip>
                <el-tooltip content="分配该用户的客户" placement="top">
                  <span class="user-action-icon user-action-icon--blue" @click="allocationFn(scope.$index, scope.row)">
                    <i class="el-icon-share"></i>
                  </span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="user-pagination">
        <span class="page-desc">当前第 {{ listQuery.PageIndex }} 页</span>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next, jumper" :current-page.sync="listQuery.PageIndex"
          :page-size="listQuery.PageSize" :page-sizes="[10, 20, 50]" :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 分配客户弹出框 -->
    <el-dialog custom-class="apple-dialog" :lock-scroll="false" :visible.sync="allocationVisible" @closed="onTransferDialogClosed" width="36%" :show-close="false">
      <div slot="title" class="apple-dialog__header">
        <span class="apple-dialog__icon-wrap"><i class="el-icon-share"></i></span>
        <span class="apple-dialog__title-text">分配客户</span>
        <button class="apple-dialog__close" @click="allocationVisible = false"><i class="el-icon-close"></i></button>
      </div>
      <div class="apple-form">
        <div style="display: flex;align-items: center;border: 1px solid #DCDFE6;border-radius: 5px;">
          <span style="font-size: 13px;">部门: &nbsp;</span>
          <el-select filterable v-model="departmentValue" size="mini" style="flex: 1;" clearable placeholder="请选择部门">
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="getDepartmentUser" size="mini">搜索</el-button>
        </div>
        <hr style="margin-top: 10px;">
        <el-table ref="Table1" :data="userData" class="userTable" style="width: 100%" height="300px"
          @selection-change="getDistributeList">
          <el-table-column align="center" show-overflow-tooltip type="selection" :selectable="selectable"></el-table-column>
          <el-table-column align="center" show-overflow-tooltip label="昵称">
            <template slot-scope="scope">{{ scope.row.NickName }}</template>
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip label="账号">
            <template slot-scope="scope">{{ scope.row.UserAccount }}</template>
          </el-table-column>
        </el-table>
      </div>
      <div class="apple-dialog__footer">
        <button class="apple-dialog-btn apple-dialog-btn--confirm" @click="toAllocation">确定分配</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { decryptData } from '@/utils/aes.js';
import request from '@/utils/request.js';
import { GetDepartList } from '@/api/department';
import { SeacherChildUserList, GetUserCustomerInfo, DeleteUserCustomerList, DistributeUserCustomer } from '@/api/UserInfo';

export default {
  data() {
    return {
      departmentValue: null,
      fileUrl: null,
      allocationVisible: false,
      distributeList: [],
      addForm: {},
      listQuery: {},
      KhList: [],
      total: 0,
      listLoading: true,
      selectedList: [],
      decryptedData: {},
      departmentOption: [],
      userData: [],
    };
  },
  created() {
    this.$nextTick(() => {
      if (localStorage.getItem('DepartmentId')*1 != 0) {
        this.departmentValue = localStorage.getItem('DepartmentId') * 1;
      }
    })
    this.listQuery = {
      PageIndex: 1,
      PageSize: 10
    }
    this.getHeadUrl()
    this.getList();
  },
  methods: {
    // 关闭弹窗时重置勾选
    onTransferDialogClosed() {
        this.distributeList = [];
        this.$refs.Table1.clearSelection();
        this.departmentValue = null;
    },
    //复选框禁用
    selectable(row, rowIndex) {
      if (this.distributeList.length == 0) {
        return true;
      } else {
        if (row.Id == this.distributeList[0].Id) {
          return true;
        } else {
          return true;
        }
      }
    },
    reset() {
      this.listQuery = {
        PageIndex: 1,
        PageSize: 10
      }
      this.getList()
    },
    // 获取部门下的员工
    getDepartmentUser() {
      let params = {
          IsContainPeerData: true
      }
      if (this.departmentValue) params.DepartmentId = this.departmentValue
      SeacherChildUserList(params)
        .then((res) => {
          this.userData = res.data.Data;
        })
        .catch((err) => {
        });
    },
    // 分配号码
    allocationFn(index, row) {
      if (row.CustomerCount <= 0) {
        this.$alert('该用户没有客户可分配', '', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
        return false
      }
      this.addForm = row
      this.getOption()
      this.allocationVisible = true
    },
    // 获取选项的内容
    getOption() {
      if (this.getOptionBool) return false
      this.getOptionBool = true
       GetDepartList({})
                .then((res) => {
                    this.departmentOption = res.data.Data;
                })
                .catch((err) => {});

      SeacherChildUserList({})
        .then((res) => {
          this.userData = res.data.Data;
        })
        .catch((err) => {
        });
    },
    // 确认分配
    toAllocation() {
      if (!this.distributeList[0]) {
        this.$message.warning("请选择要分配的用户!");
        return false
      }
       console.log("分----", this.addForm.CustomerCount);
      console.log("分----", this.distributeList.length);
       if(this.addForm.CustomerCount < this.distributeList.length ){
          this.$message.warning("用户数量请小于客户数量");
          return false
       }
      this.$confirm(`确定要将选中用户下的客户分配给  ${this.distributeList[0].NickName}-${this.distributeList[0].UserAccount
        }${this.distributeList[0].RoleName ? `(${this.distributeList[0].RoleName})` : ""} 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.allocationVisible = false
        let params = {
          "OldUserId": this.addForm.Id,
          "NewUserId": this.distributeList[0].Id,
          "NewUserIds": this.distributeList.map(user => user.Id)
        }

        DistributeUserCustomer(params)
          .then((res) => {
            if (res.data.ErrorCode == "2000") {
              this.$message.success("分配成功");
              this.getList()
            } else {
              this.$message.error(res.data.Message);
            }
          })
          .catch((err) => { });
      }).catch(() => {
      });


    },

    // 拼接上传头像地址
    getHeadUrl() {
      let encryptionKey = localStorage.getItem('encryptionKey');
      let userInfo = localStorage.getItem('userInfo');
      this.decryptedData = JSON.parse(decryptData(userInfo, encryptionKey));
      this.fileUrl = `${request.defaults.baseURL}/file/FileUpload?token=${this.decryptedData.Token}`
    },
    // 单个删除客户
    handleDelete(index, row) {
      if (!this.decryptedData.IsDelDataAuth) {
        this.$alert('无删除权限,请联系管理员', '', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
          }
        })
        return false
      }
      if (row.CustomerCount <= 0) {
        this.$alert('该用户的客户列表为空', '', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
        return false
      }

      this.$confirm(`此操作将永久删除用户 ${row.NickName} 的客户数据, 是否继续?`, '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let params = {
          "UserId": row.Id
        }

        DeleteUserCustomerList(params)
          .then((res) => {
            if (res.data.ErrorCode == "2000") {
              this.$message.success('删除成功');
              this.getList()
            } else {
              this.$message.error(res.data.Message);
            }
          })
          .catch((err) => { });
      }).catch(() => {

      });
    },
    handleSizeChange(val) {
      // 改变列表显示条数
      this.listQuery.PageIndex = 1;
      this.listQuery['PageSize'] = val;
      this.getList();
    },
    handleCurrentChange(val) {
      // 改变列表显示页数
      this.listQuery.PageIndex = val;
      this.getList();
    },

    getList() {
      // 获取数据列表
      this.listLoading = true;
      GetUserCustomerInfo(this.listQuery)
        .then((res) => {
          this.listLoading = false;
          this.KhList = res.data.Data;
          this.total = res.data.Total;
        })
        .catch((err) => {
          this.listLoading = false;
        });


    },
    getDistributeList(val) {
      this.distributeList = val;
    },
    handleSelectionChange(val) {
      // 批量选择行数
      this.selectedList = val;
    }
  }
};
</script>

<style lang="less" scoped>
.user-page {
  background: #f5f5f7;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.user-page__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px 12px;
  flex-shrink: 0;
}

.user-page__header-left {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 8px;
}

.user-page__title {
  font-size: 20px;
  font-weight: 700;
  color: #1d1d1f;
}

.user-page__subtitle {
  font-size: 11px;
  color: #86868b;
}

.user-content-card {
  flex: 1;
  min-height: 0;
  margin: 8px 20px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.user-search-bar {
  display: flex;
  align-items: center;
  padding: 12px 16px 8px;
  flex-shrink: 0;
}

.user-search-main {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-search-field {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 260px;
  height: 36px;
  padding: 0 12px;
  border-radius: 8px;
  background: #f5f5f7;
  border: 1px solid transparent;
  transition: border-color 0.15s, background 0.15s;

  &:focus-within {
    background: #fff;
    border-color: #007aff;
    box-shadow: 0 0 0 3px rgba(0, 113, 227, 0.15);
  }

  .user-search-field__icon {
    font-size: 14px;
    color: #86868b;
    flex-shrink: 0;
  }

  .user-search-field__input {
    flex: 1;
    border: none;
    background: transparent;
    font-size: 13px;
    color: #1d1d1f;
    outline: none;
    height: 100%;

    &::placeholder {
      color: #86868b;
    }
  }
}

.user-search-btn {
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  background: #007aff;
  color: #fff;
  transition: background 0.15s;

  &:hover {
    background: #0071e3;
  }

  &--ghost {
    background: rgba(0, 0, 0, 0.05);
    color: #3c3c43;

    &:hover {
      background: rgba(0, 0, 0, 0.09);
    }
  }
}

.user-table-wrap {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 0;
  display: flex;
  flex-direction: column;
  background: #f5f5f7;
}

::v-deep .apple-table.el-table {
  background: transparent;

  &::before {
    display: none;
  }

  .el-table__header-wrapper {
    background: #f5f5f7 !important;
  }

  .el-table__header tr {
    background: transparent !important;
  }

  thead th {
    background: #f5f5f7 !important;
    color: #86868b;
    font-size: 10px;
    font-weight: 600;
    border: none !important;
    padding: 4px 0;
  }

  thead th .cell {
    background: transparent !important;
    color: #86868b;
    font-size: 10px;
    font-weight: 600;
    border: none !important;
  }

  .el-table__body {
    border-collapse: collapse;
  }

  tbody tr {
    background: transparent !important;
  }

  tbody td {
    background: #fff !important;
    font-size: 13px;
    color: #1d1d1f;
    padding: 6px 0 !important;
    border-bottom: 6px solid #f5f5f7 !important;
    border-top: none !important;
    border-right: none !important;
  }

  tbody td .cell {
    font-size: 13px;
  }

  tbody tr td:first-child {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  tbody tr td:last-child {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  tr:hover td {
    background: #fff !important;
  }

  .el-table__fixed-right {
    thead th {
      background: #f5f5f7 !important;
    }
    &::before {
      display: none !important;
    }
    .el-table__fixed-header-wrapper {
      background: #f5f5f7 !important;
    }
  }
}

.user-action-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s, transform 0.1s;
  margin: 0 2px;

  &:hover {
    transform: scale(1.1);
  }

  &--red {
    color: #ff3b30;
    background: rgba(255, 59, 48, 0.1);

    &:hover {
      background: rgba(255, 59, 48, 0.18);
    }
  }

  &--blue {
    color: #007aff;
    background: rgba(0, 122, 255, 0.1);

    &:hover {
      background: rgba(0, 122, 255, 0.18);
    }
  }
}

.user-pagination {
  padding: 12px 20px;
  border-top: 0.5px solid rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;

  .page-desc {
    font-size: 12px;
    color: #86868b;
  }
}
</style>

<style>
.apple-dialog.el-dialog {
  border-radius: 18px !important;
  overflow: hidden;
  box-shadow:
    0 24px 64px rgba(0, 0, 0, 0.18),
    0 8px 24px rgba(0, 0, 0, 0.1) !important;
  border: none !important;
}

.apple-dialog .el-dialog__header {
  padding: 0 !important;
  border-bottom: none !important;
}

.apple-dialog .el-dialog__body {
  padding: 0 !important;
}

.apple-dialog .el-dialog__footer {
  display: none !important;
}

.apple-dialog__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 20px 0;
  position: relative;
}

.apple-dialog__icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(145deg, #0071e3, #0077ed);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
  box-shadow: 0 3px 10px rgba(0, 113, 227, 0.35);
}

.apple-dialog__title-text {
  flex: 1;
  font-size: 17px;
  font-weight: 600;
  color: #1d1d1f;
  letter-spacing: -0.02em;
}

.apple-dialog__close {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.06);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #86868b;
  font-size: 13px;
  transition: background 0.15s;
  flex-shrink: 0;
}

.apple-dialog__close:hover {
  background: rgba(0, 0, 0, 0.1);
  color: #1d1d1f;
}

.apple-form {
  padding: 20px 20px 4px;
}

.apple-form__row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.apple-form__item {
  flex: 1;
  margin-bottom: 0 !important;
}

.apple-form__item .el-form-item__content {
  margin-left: 0 !important;
}

.apple-form__label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #86868b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}

.apple-dialog__footer {
  display: flex;
  gap: 10px;
  padding: 16px 20px 20px;
  justify-content: flex-end;
  border-top: 0.5px solid rgba(0, 0, 0, 0.08);
  margin-top: 8px;
}

.apple-dialog-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 9px 22px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
  letter-spacing: -0.01em;
  min-width: 72px;
}

.apple-dialog-btn:active {
  transform: scale(0.97);
  opacity: 0.85;
}

.apple-dialog-btn--cancel {
  background: rgba(0, 0, 0, 0.06);
  color: #1d1d1f;
}

.apple-dialog-btn--cancel:hover {
  background: rgba(0, 0, 0, 0.1);
}

.apple-dialog-btn--confirm {
  background: #0071e3;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 113, 227, 0.3);
}

.apple-dialog-btn--confirm:hover {
  background: #0077ed;
}
</style>
